import { useEffect, useState } from "react";
import { ArrowRight } from "@phosphor-icons/react";
import { scrollToId } from "../lib/scroll";

export const StickyCTA = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const target = document.getElementById("audit-form");
    if (!target) return;
    const obs = new IntersectionObserver(([entry]) => setHidden(entry.isIntersecting), {
      threshold: 0.12,
    });
    obs.observe(target);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-black/5 bg-cream/90 p-4 backdrop-blur-md transition-transform duration-300 md:hidden ${
        hidden ? "translate-y-full" : "translate-y-0"
      }`}
    >
      <button
        data-testid="sticky-cta-button"
        onClick={() => scrollToId("#audit-form")}
        className="btn-primary w-full"
      >
        Get My Free Audit
        <ArrowRight weight="bold" size={18} />
      </button>
    </div>
  );
};
